// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2G2Xk","title":"styles_title__AGK3_","subTitle":"styles_subTitle__2PnOR","textContainer":"styles_textContainer__75h6L"};